import { Injectable } from '@angular/core';
import { constants } from 'src/app/config/constant';
import { environment } from 'src/environments/environment';
import { MockSignalRService } from './mock.signalr.service';
import { IAppManagerResponse } from '../model/app-manager.respose.interface';

@Injectable({
  providedIn: 'root'
})
export class AppManagerService {
  private proxy: any;
  private connection;
  private connState: Array<string> = [
    "Connecting",
    "Connected",
    "Reconnecting",
    "Disconnecting",
    "Disconnected",
  ];
  private currConnState: number = 4;

  constructor(public config: constants, public mock: MockSignalRService) {
    // this.connection = $.hubConnection(
    //     environment.signalRServicesConfig.appManager.url
    // );
    this.connection = (environment.production ? ($ as any) : this.mock).hubConnection(
      environment.signalRServicesConfig.appManager.url
    );
    this.proxy = this.connection.createHubProxy(
      environment.signalRServicesConfig.appManager.hubName
    );
    this.proxy.on("_a", function () { });
  }


  public startConnection() {
    return (this.connection
      .start() as Promise<any | void>).then((res: any) => {
        console.log("App Manager Hub connection started...");
        res = true; return res;
      }).catch((err: any) => {
        console.log("Error while establishing connection, retrying...");
      });
  }

  public getSignalRConn(success: any, fail: any) {
    (this.connection
      .start() as Promise<any | void>).then(() => {
        success(this.proxy);
      }).catch((err: any) => { fail(err); });
  }

  public callSignalR(key: string, className: string, methodName: string, reqParams: any): Promise<IAppManagerResponse> {
    if (!this.config.KIOSK_ENABLED) {
      // console.log({ key, className, methodName, reqParams })
      return new Promise((resolve, reject) => {
        // console.log(reqParams, [key, className, methodName]);
        resolve({} as IAppManagerResponse)
      })
    }
    var ISignalRVM = {
      Key: key === undefined ? "" : key,
      ClassName: className,
      MethodName: methodName,
      ReqParams: reqParams,
    };
    return (this.connection
      .start() as Promise<any | void>)
      .then((res: any) => {
        return this.proxy.invoke("action", ISignalRVM).then((response: any) => {
          try {
            return response;
          } catch (error) {
            console.log("Error while invoking singalr method - " + JSON.stringify(error));
          }
        });
      })
      .catch((err: any) => {
        console.log("Error while establishing connection, retrying..." + err);
      });
  }

}
